/** Formatting shared by the CRM screens. Amounts are in the company's currency. */
import { company } from "@/mock/masters";

export const money = (value, currency = company.currency) =>
  value === null || value === undefined
    ? "—"
    : `${currency} ${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

// 1.2M, 450K: for cards and charts where the full figure does not fit.
export const compactMoney = (value, currency = company.currency) => {
  if (value === null || value === undefined) return "—";
  const n = Number(value);
  const short = n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${Math.round(n / 1e3)}K` : `${n}`;
  return `${currency} ${short}`;
};

export const percent = (value, digits = 0) => (value === null || value === undefined ? "—" : `${Number(value).toFixed(digits)}%`);

const DAY = 86400000;
const startOfDay = (d) => new Date(new Date(d).toDateString()).getTime();

export const daysSince = (value) => (value ? Math.floor((startOfDay(Date.now()) - startOfDay(value)) / DAY) : null);
export const daysUntil = (value) => (value ? Math.floor((startOfDay(value) - startOfDay(Date.now())) / DAY) : null);

// "in 3 days", "2 days ago", "today": for due dates and last contact.
export const relativeDays = (value) => {
  const d = daysUntil(value);
  if (d === null) return "—";
  if (d === 0) return "today";
  if (d === 1) return "tomorrow";
  if (d === -1) return "yesterday";
  return d > 0 ? `in ${d} days` : `${-d} days ago`;
};

// Sample dates are written relative to today so the prototype never goes stale.
export const daysFromNow = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

/** Bootstrap classes for a soft badge in one of the theme's tones. */
export const toneClass = (tone = "secondary") =>
  tone === "light" ? "bg-light text-dark border" : `bg-${tone}-subtle text-${tone} border border-${tone}-subtle`;

export const priorityTone = (priority) =>
  ({ low: "secondary", medium: "info", high: "warning", critical: "danger" })[priority] ?? "secondary";

/** The tone a stage is shown in follows its kind, not its name. */
export const stageTone = (kind) => ({ open: "primary", won: "success", lost: "danger", paused: "warning" })[kind] ?? "secondary";

export const healthTone = (health) =>
  ({ healthy: "success", needs_attention: "warning", at_risk: "danger", critical: "danger" })[health] ?? "secondary";

export const riskTone = (risk) => ({ normal: "success", low: "success", medium: "warning", at_risk: "warning", high: "danger", critical: "danger" })[risk] ?? "secondary";
